
import {
  addPackageToWorkspace,
  allWorkspacesStateSingleton,
  createEmptyPackage
} from '@/firebase/database';
import {
  getAllPackagesAsync,
  removeDbPackage,
  savePackage
} from '@/firebase/databaseDependencyInjectables';
import { defineComponent } from 'vue';
import ControlPackage from '@/modules/packageCanvas/components/ControlPackage.vue';
import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';
import TextBubble from '@/modules/globalModule/components/TextBubble.vue';
import MountedExecute from '../modules/MountedExecute.vue';
import { v4 } from 'uuid';
import dialog from '@/modules/globalModule/components/dialog';
import { workspaceToZip } from '@/codeGeneration/codeGen';
import { useGlobalStore } from '@/modules/globalModule/store';
import { removeElement } from '@/modules/globalModule/components/helperMethods';
import ListPackage from '../components/ListPackage.vue';
import NewEmptyPackage from '../components/NewEmptyPackage.vue';
import ActiveMessagesPopup from '@/modules/nodesCanvasModule/components/ActiveMessagesPopup.vue';
export default defineComponent({
  name: 'PackageCanvas',
  components: {
    ControlPackage,
    TextBubble,
    MountedExecute,
    ActiveMessagesPopup,
    ListPackage,
    NewEmptyPackage
  },
  data(): {
    workspaceId: string;
    db: { info?: any; isSet: Boolean };
    packages: Array<PackageT>;
    newPackageCount: number;
    editingPackages: boolean;
    displayPackages: Array<PackageT>;
    currMessageFilter: string;
    listView: boolean;
    listNewPackageName: string;
  } {
    return {
      workspaceId: this.$route.params.workspaceId as string,
      db: allWorkspacesStateSingleton(),
      packages: [],
      newPackageCount: 0,
      editingPackages: false,
      displayPackages: [],
      currMessageFilter: '',
      listView: false,
      listNewPackageName: ''
    };
  },
  methods: {
    // Must remount to load database after a page reset.
    async reMount(count: number = 0) {
      console.log('remounting');
      const globalStore = useGlobalStore();
      if (!globalStore.loaded) globalStore.loadWorkspace(this.workspaceId);
      this.packages = [];
      const packages = await getAllPackagesAsync(this.workspaceId);
      console.log(packages);
      if (!packages && count < 10) {
        setTimeout(() => this.reMount(count + 1), 1000);
        return;
      }
      for (let packageId in packages) {
        this.packages.push(packages[packageId]);
      }
      this.packages = this.packages.sort((pkg1: PackageT, pkg2: PackageT) => {
        if (pkg1.robotPackage && !pkg2.robotPackage) return 1;
        if (pkg2.robotPackage && !pkg1.robotPackage) return -1;
        return pkg1.name.localeCompare(pkg2.name);
      });
      console.log(this.packages);
    },
    editPackageName(newName: string, currPackage: PackageT) {
      currPackage.name = newName;
      savePackage(this.workspaceId, currPackage.id, currPackage);
    },
    createNewPackage(packageName: string) {
      console.log(`newplg: ${packageName}`);
      const globalStore = useGlobalStore();
      if (packageName === '') {
        if (!this.listView) this.newPackageCount -= 1;
        return;
      }
      this.listNewPackageName = '';
      const newPackage = createEmptyPackage({ id: v4(), name: packageName });
      addPackageToWorkspace(this.workspaceId, newPackage);
      globalStore.packages.push(newPackage);
      globalStore.saveData();
      if (!this.listView) this.newPackageCount -= 1;
      this.reMount();
    },
    async deletePackage(name: string, id: string) {
      const globalStore = useGlobalStore();
      let confirmed = await dialog
        .okText('Yes')
        .cancelText('No')
        .confirm(`Are you sure you want to delete the package "${name}"?`);
      if (confirmed) {
        removeDbPackage(this.workspaceId, id);
        removeElement(globalStore.packages, globalStore.getPackage(id));
        removeElement(this.packages, globalStore.getPackage(id));
        this.reMount();
      }
    },
    setPopupVisibility(val: boolean) {
      if (!val) {
        this.displayPackages = [];
        this.currMessageFilter = '';
      }
    },
    setPackageMessages(pkgId: string, filter: string) {
      const targetPackage = this.packages.find((pkg) => pkg.id === pkgId);
      if (targetPackage) {
        this.displayPackages = [targetPackage];
      }
      this.currMessageFilter = filter;
    },
    generateWorkspaceZip() {
      workspaceToZip(this.workspaceId);
    },
    toggleListView() {
      this.listView = !this.listView;
      if (this.listView) this.newPackageCount = 0;
    }
  }
});
